import store from '@/store'

// 过滤门店类型
const filterStoreType = function(value) {
  if (typeof value === 'string' || typeof value === 'number') {
    let index = -1
    const arr = store.state.dictionaries.storeTypes
    arr.forEach((item, i) => {
      if (item.value === String(value)) {
        index = i
      }
    })
    if (index !== -1) {
      return arr[index].key
    } else {
      return ''
    }
  } else {
    return value
  }
}
/**
 * 返回添加前缀后的门店组名称，前缀：C影吧 H酒店 F足浴
 * @param {String} value
 * @returns {String}
 */
const filterStoreGroup = function(value, type) {
  let result = ''
  if (typeof value === 'string') {
    const types = {
      1: 'C',
      2: 'H',
      3: 'F'
    }
    const prefix = types[type]
    if ((typeof type === 'string' || typeof type === 'number') && typeof prefix === 'string') {
      result = prefix + ' - ' + value
    } else {
      result = value
    }
  } else {
    result = value
  }
  return result
}

/**
 * 返回添加前缀后的软件名称，前缀：C影吧 H酒店 F足浴 P公用
 * @param {String} value
 * @param {Array} params 必传值，确定前缀，门店组数组
 * @returns {String}
 */
const filterSoftwareName = function(value, params) {
  let result = ''
  if (typeof value === 'string') {
    const types = {
      1: 'C',
      2: 'H',
      3: 'F',
      'multi': 'P'
    }
    if (Array.isArray(params)) {
      // 门店组数组对应的前缀数组
      const prefixes = []
      params.forEach(item => {
        const prefix = types[item]
        // 去重
        if (!!prefix && !prefixes.includes(prefix)) {
          prefixes.push(prefix)
        }
      })
      let prefix
      if (prefixes.length === 1) {
        prefix = prefixes.join('')
      } else if (prefixes.length > 1) {
        prefix = types.multi
      } else {
        prefix = ''
      }
      result = prefix + ' - ' + value
    } else {
      result = value
    }
  } else {
    result = value
  }
  return result
}


/**
 * 过滤文件尺寸
 * @param size
 * @return {*|string}
 */
 export function filterFileSize(size, unit = 'MB') {
  size = Number(size)
  const suffixes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
  const step = 1024
  let i = suffixes.indexOf(unit.toUpperCase())
  i = i !== -1 ? i : 0
  while (size >= step)  {
    size = size / step
    i++
  }
  return (Math.floor(size * 100) / 100) + suffixes[i]
}

// 服务器授权状态
const SERVER_TYPE_LIST = [
  { value: 1, label: '正常' },
  { value: 2, label: '即将授权' },
  { value: 3, label: '即将过期' },
  { value: 4, label: '停用' }
]
/**
 * 过滤服务器授权状态
 * @param type
 * @return {*|string}
 */
export function filterServerType(type) {
  const res = SERVER_TYPE_LIST.filter(item => item.value === Number(type))[0] || ''
  return res && res.label
}

// 服务器在线状态
const SERVER_STATUS = [
  { value: 0, label: '离线' },
  { value: 1, label: '在线' }
]
/**
 * 过滤服务器在线状态
 * @param status
 * @return {*|string}
 */
export function filterServerStatus(status) {
  const res = SERVER_STATUS.filter(item => item.value === Number(status))[0] || ''
  return res && res.label
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (/^[0-9]{0,}$/.test(time + '')) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  return format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
}

export function parsePayType(val) {
  const payTypes = {
    1: { icon: 'cash', label: '现金', value: 1 },
    2: { icon: 'member', label: '会员卡', value: 2 },
    3: { icon: 'alipay', label: '支付宝', value: 3 },
    4: { icon: 'wechat', label: '微信', value: 4 },
    5: { icon: 'integral', label: '积分', value: 5 },
    6: { icon: 'alipay', label: '支付宝(自收)', value: 6 },
    7: { icon: 'wechat', label: '微信(自收)', value: 7 },
    8: { icon: 'bank_card', label: '银行卡', value: 8 },
    9: { icon: 'apple', label: 'Apple Pay', value: 9 },
    10: { icon: 'group', label: '美团', value: 10 },
    11: { icon: 'douyin', label: '抖音', value: 11 },
    12: { icon: 'koubei', label: '口碑', value: 12 },
    13: { icon: 'exemption', label: '免单', value: 13 },
    14: { icon: 'alipay', label: '预约', value: 14 }
  }
  return payTypes[val] || null
}


export default {
  filterStoreType,
  filterStoreGroup,
  filterSoftwareName,
  filterFileSize,
  filterServerType,
  filterServerStatus,
  parseTime,
  parsePayType
}



// WEBPACK FOOTER //
// ./src/utils/filters.js